export interface AnalyticsStat {
  icon: string
  value: number
  suffix: string
  label: string
  description?: string
}

export const analyticsData: AnalyticsStat[] = [
  {
    icon: 'Users',
    value: 120,
    suffix: '+',
    label: 'Youth Trained',
    description: 'Young people trained in various skills'
  },
  {
    icon: 'Briefcase',
    value: 10,
    suffix: '+',
    label: 'Jobs Created',
    description: 'Employment opportunities generated'
  },
  {
    icon: 'Heart',
    value: 20,
    suffix: '+',
    label: 'In-Kind Entrepreneurs Supported',
    description: 'Women entrepreneurs supported with in-kind loans'
  },
  {
    icon: 'Bird',
    value: 4000,
    suffix: '+',
    label: 'Chickens Raised',
    description: 'Chickens raised in our sustainable farming initiative'
  },
  {
    icon: 'Store',
    value: 1,
    suffix: '',
    label: 'Modern Tailoring Hub',
    description: 'State-of-the-art tailoring and printing facility'
  }
]

export default analyticsData
